import type {
  Conversation,
  ConversationContext,
} from '@stripe-internal/conversations-client';

import type {AppError, AppTriggerPoint} from '../../core/types';
import type {
  ConversationOverview,
  ConversationsApiConversationStatus,
} from '../../core/lib/api/conversations';

export type {ConversationOverview};

export type ControllerSuccess<T> = {
  type: 'success';
  data: T;
};

export type ControllerError = {
  type: 'error';
  error: string;
  code?: number;
  errorId?: string;
};

export type ControllerResult<T> = Promise<
  ControllerSuccess<T> | ControllerError
>;

export type CreateConversationParams = {
  initialMessage?: string;
  context?: Partial<ConversationContext>;
  data?: Record<string, unknown>;
  connect?: boolean;
  fetch?: boolean;
};

export type ListConversationFilters = {
  status?: ConversationsApiConversationStatus;
  limit?: number;
  triggerPoint?: AppTriggerPoint;
  conversationIds?: string[];
};

export interface ConversationsControllerApi {
  create: (params?: CreateConversationParams) => ControllerResult<Conversation>;
  get: (
    id: string,
    {context}: {context?: Partial<ConversationContext>},
  ) => ControllerResult<Conversation | null>;
  list: (
    filters?: ListConversationFilters,
  ) => ControllerResult<ConversationOverview[]>;
  end: (id: string) => ControllerResult<void>;
}

export const NEW_CONVERSATION_ID = 'new-conversation';

export type ConversationSelection = {
  id: string;
  conversation: Conversation | null;
  loadStatus: 'idle' | 'loading' | 'success' | 'error';
  error: AppError | ControllerError | null;
};
